<template>
  <div>
    <el-row :gutter="20" v-for="(row, index) in rows" :key="index">
      <template v-for="item in row">

        <el-col v-if="isCol(item)" :span="item.span" :key="item.id"
          v-html="item.body" /><!-- eslint-disable-line vue/no-v-text-v-html-on-component -->

        <el-col v-if="isRow(item)" :span="24" :key="item.id">
          <h2>
            <a :name="anchor(item.heading)">
              {{ item.heading }}
            </a>
          </h2>
        </el-col>

      </template>
    </el-row>
  </div>
</template>

<script>
import slugify from 'slugify';
import log from '@/configured/logger';

export default {
  name: 'BlockContent',
  props: ['blocks'],
  computed: { rows },
  methods: {
    isCol,
    isRow,
    anchor: (value) => '#' + slugify(value),
  }
}

/////////////

function isCol(item) {
  return item.type === 'column';
}

function isRow(item) {
  return item.type === 'row';
}

// Groups the blocks into rows
function rows() {
  if (!this.blocks) {
    return [];
  }

  const maxSpan = 24;
  const rows = [];
  let row = [];
  let span = 0;

  function finishRow() {
    if (row.length) {
      rows.push(row);
    }
    row = [];
    span = 0;
  };

  this.blocks.forEach((block, index) => {
    const newBlock = Object.assign({}, block);
    if (block.type === 'row') {
      finishRow();
      return rows.push([newBlock]);
    }

    newBlock.span = parseInt(block.span);
    let nextSpan = span + block.span;

    if (nextSpan > maxSpan) {
      // We need to close out the existing row and create a new one
      finishRow();
    }
    row.push(newBlock);
    span = nextSpan;
  });

  finishRow();

  log.debug("Calculated rows", rows);
  return rows;
}
</script>
